import React, { useEffect, useState } from 'react'
import { Btn, CustomCalendar, CustomModal } from '../../../../components'
import MovimentacaoLastMileHttp from '../../../../services/api/https/patrimonio/movimentacao-last-mile.http'
import { convertToJsDate } from '../../../../services/util/date.service'

export default function ModalNovaPrestacaoContas({ visible, onResponse, selectedPrestacaoContas }) {
  const [isLoading, setIsLoading] = useState(false)
  const [prestacaoContas, setPrestacaoContas] = useState(null)

  useEffect(() => {
    if (selectedPrestacaoContas) {
      setPrestacaoContas({
        ...selectedPrestacaoContas,
        data_prestacao_contas: selectedPrestacaoContas.data_prestacao_contas
          ? convertToJsDate(selectedPrestacaoContas.data_prestacao_contas)
          : '',
      })
    }
  }, [visible])

  // Events
  const onBtnSalvarClick = () => {
    setIsLoading(true)
    if (prestacaoContas) {
      MovimentacaoLastMileHttp.saveNovaPrestacaoContas(prestacaoContas)
        .then(savedPrestacaoContas => {
          setIsLoading(false)
          onResponse('success', savedPrestacaoContas)
        })
        .catch(error => {
          setIsLoading(false)
          onResponse('error', error)
        })
    }
  }

  //Render
  return (
    <CustomModal
      header={'Nova Prestação de Contas'}
      onClose={() => onResponse('close')}
      width={400}
      isVisible={visible}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <CustomCalendar
            label={'Data Prestação de Contas'}
            value={prestacaoContas ? prestacaoContas.data_prestacao_contas : ''}
            onChange={value =>
              setPrestacaoContas({ ...prestacaoContas, data_prestacao_contas: value })
            }
          />
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onBtnSalvarClick}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
